import { render, staticRenderFns } from "./my-courses.vue?vue&type=template&id=4fa865a6&scoped=true"
import script from "./my-courses.vue?vue&type=script&lang=js"
export * from "./my-courses.vue?vue&type=script&lang=js"
import style0 from "./my-courses.vue?vue&type=style&index=0&id=4fa865a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa865a6",
  null
  
)

export default component.exports